export class BaseParams {
    skey = process.env.SKEY
    act: number
    jm = 0

    constructor(act: number) {
        this.act = act
    }
}
